export default __webpack_public_path__ + "static/media/instagram.01a3dc83.png";